module.exports = __webpack_public_path__ + "static/media/trio-rob-gabe-andrew-yoshi.1b616e29.jpg";